import queryString from "query-string"
import { reportErrorMessage } from "#/utils/ErrorReporting"
import { validateUrl } from "./Regexes"
import Settings from "./CarrotConfig"

// Built from the public server-app origin (backend ServerAppUrl), NOT CARROT_BACKEND_URL: SP-initiated SSO must
// start on the same host as the SAML ACS, or the correlation cookie is lost (admin.* vs www/stage.get-carrot.com).
const carrotSamlExternalLoginEndpoint = `${Settings.CARROT_PUBLIC_BACKEND_URL}/saml2/ExternalLogin`

// Forwards only the explicit returnUrl (validated against the app allowlist) and lets the SamlAcsCallback resolve the
// admin-vs-member landing server-side. Callers that need to preserve a member's current path pass window.location.href.
export const redirectToSamlExternalLogin = (entityId: string, returnUrl?: string | null) => {
  let allowedReturnUrl: string | undefined
  if (returnUrl) {
    if (validateUrl(returnUrl)) {
      allowedReturnUrl = returnUrl
    } else {
      reportErrorMessage(`returnUrl provided at login is not allowed: ${returnUrl}`)
    }
  }
  window.location.replace(
    carrotSamlExternalLoginEndpoint + "?" + queryString.stringify({ returnUrl: allowedReturnUrl, entityId })
  )
}

// A member's deep-linked path is their post-SSO destination; the bare login page (root) is not — return undefined
// there so the SAML callback resolves admin-vs-member landing by role instead of pinning it to the member root.
export const getDeepLinkReturnUrl = (): string | undefined =>
  window.location.pathname === "/" ? undefined : window.location.href
